function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Group } from '../../../../containers';
import { useTestId } from '../../../../utils';
import { useMultiStyleConfig } from '../../../../utils/use-style-config';
import { Box } from '../../Box';
import { getOptionsGroupedBySection } from '../BaseSelect.utils';
import { EmptyState } from './EmptyState';
import { Section } from './Section';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DropdownMenuContent = _ref => {
  var {
    hasSections,
    options,
    isLoading,
    loadingStateComponent,
    emptyState,
    shouldShowCreatableOption,
    creatableOptionComponent,
    closeMenu,
    resetHighlightedIndex,
    renderOption
  } = _ref;
  var styles = useMultiStyleConfig('BaseSelect', {
    shouldShowCreatableOption
  });
  var getTestId = useTestId('base-select');
  return /*#__PURE__*/_jsx(Box, {
    __css: styles['dropdownMenuContent'],
    children: /*#__PURE__*/_jsxs(Group, {
      hasDivider: true,
      spacing: "none",
      width: "full",
      variant: "vertical",
      children: [isLoading ? loadingStateComponent : options.length > 0 ? /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
        __css: styles['optionsContainer']
      }, getTestId('options-container')), {}, {
        children: hasSections ? /*#__PURE__*/_jsx(Group, {
          variant: "vertical",
          width: "full",
          spacing: "none",
          hasDivider: true,
          children: Object.entries(getOptionsGroupedBySection(options)).map((_ref2, index) => {
            var _sectionContent$secti;

            var [sectionLabel, sectionContent] = _ref2;
            return /*#__PURE__*/_jsx(Section, {
              onHover: resetHighlightedIndex,
              label: sectionLabel,
              isVerified: ((_sectionContent$secti = sectionContent.section) === null || _sectionContent$secti === void 0 ? void 0 : _sectionContent$secti.icon) === 'verified',
              children: sectionContent.options.map(option => renderOption(option, option.index))
            }, "".concat(sectionLabel, "-").concat(index));
          })
        }) : options.map((option, index) => renderOption(option, index))
      })) : emptyState && !shouldShowCreatableOption && /*#__PURE__*/_jsx(EmptyState, {
        emptyState: emptyState,
        closeMenu: closeMenu
      }), shouldShowCreatableOption && !isLoading && creatableOptionComponent]
    })
  });
};
DropdownMenuContent.displayName = 'BaseSelect.DropdownMenuContent';
//# sourceMappingURL=DropdownMenuContent.js.map